{
    "WebexAuth_UserIntro": "Hoi **{}**,",
    "WebexAuth_UserIntro_2": "CX Analytics vraagt om toegang tot uw Webex Calling Tenant",
    "WebexAuth_AdminConsent": "Verleen beheerderstoestemming",
    "WebexAuth_Authorise": "Autoriseren",
    "WebexAuth_ConsentedMessage": "Beheerderstoestemming verleend, klik op Autoriseren om door te gaan",
    "WebexAuth_AuthorisedMessage": "Vergunning verleend",
    "WebexAuth_Decline": "Afwijzen",
    "WebexAuth_Error_Unknown": "Er is een onbekende fout opgetreden. Probeer het opnieuw. Neem contact op met uw systeembeheerder als het probleem aanhoudt.",
    "NAME": "WebexAuthLanguage"
}